<template>
  <div>
    <nav class="navbar navbar-default navbar-static-top">
      <div class="container">
        <navigation-logo></navigation-logo>

        <div class="collapse navbar-collapse" id="app-navbar-collapse">
          <ul class="nav navbar-nav">
            <navigation-link
                v-for="(linkSection, index) in linkSections"
                :key="index"
                :text="linkSection.text"
                :url="linkSection.url"
                :section="linkSection.section"
                :links="linkSection.links"
            ></navigation-link>
          </ul>

          <ul class="nav navbar-nav navbar-right">
            <li style="font-size: 20px">
              <a href="#" @click.prevent="showSearch = !showSearch">
                <i class="fa fa-search"></i>
              </a>
            </li>

            <navigation-user-menu></navigation-user-menu>
          </ul>
        </div>
      </div>
    </nav>

    <transition name="slide">
      <div v-if="showSearch">
        <div class="container">
          <form @submit.prevent="search" style="margin: 10px 0">
            <div class="row">
              <div class="col-xs-20">
                <input v-model="term" type="text" class="form-control"
                       placeholder="Enter search term...">
              </div>

              <div class="col-xs-4">
                <button type="submit" class="btn btn-black btn-block">
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<style>
.slide-enter-active {
  transition: all 0.3s ease-in;
}

.slide-leave-active {
  transition: all 0.3s cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>

<script>
import store from '@/store'
import NavigationLink from '@/components/Layout/Navigation/NavigationLink'
import NavigationLogo from '@/components/Layout/Navigation/NavigationLogo'
import NavigationUserMenu from '@/components/Layout/Navigation/NavigationUserMenu'
import Permissions from '@/mixins/Permissions'
import moment from "moment/moment";

export default {
  components: {NavigationLink, NavigationLogo, NavigationUserMenu},

  mixins: [Permissions],

  data() {
    return {
      shared: store,

      showSearch: false,
      term: ''
    }
  },

  computed: {
    linkSections() {
      return [
        {
          text: 'Dashboards',
          section: 'dashboards',
          links: [
            {url: '/dashboards/my-focus', text: 'My Focus'},
            {url: '/users/' + this.shared.user.id, text: 'My Performance'},
            {url: '/dashboards/advertisement', text: 'Advertisement'},
            {url: '/dashboards/subscriptions', text: 'Subscriptions'},
            {url: '/dashboards/meetings', text: 'Meetings'},
            {url: '/dashboards/opportunities', text: 'Opportunities'},
            {url: '/dashboards/competitions', text: 'Competitions'},
            {url: '/dashboards/sales', text: 'Sales'},
            {
              url: '/dashboards/partnership-forecast',
              text: 'Partnership Forecast',
              display: this.hasPermission('admin')
            },
            {
              url: '/dashboards/membership-forecast',
              text: 'Membership Forecast',
              display: this.hasPermission('admin')
            },
            {url: '/dashboards/topics', text: 'Topics'},
          ]
        },
        {
          text: 'Relations',
          section: 'relations',
          links: [
            {text: 'Advertising', url: '/orders'},
            {text: 'Partnerships', url: '/partnerships?filter[status]=active&filter[portal_company_user_id]=' + this.shared.user.id},
            {text: 'Memberships', url: '/memberships'},
            {text: 'Reminders', url: '/reminders?filter[status]=unresolved&filter[user_id]=' + this.shared.user.id + '&filter[remind_to]=' + moment().add(3, 'days').format('YYYY-MM-DD')},
            {text: 'People', url: '/people'},
            {text: 'Projects', url: '/projects?filter[status]=active'},
          ]
        },
        {
          text: 'Companies',
          section: 'companies',
          url: '/companies'
        },
        {
          text: 'Content',
          section: 'content',
          url: '/content'
        },
        {
          text: 'Publications',
          section: 'publications',
          links: [
            {text: 'Publications', url: '/publications'},
            {text: 'Capacity', url: '/capacity'}
          ]
        },
        {
          text: 'Administration',
          section: 'administration',
          links: [
            {
              url: '/invoices',
              text: 'Invoices'
            },
            {
              url: '/portals',
              text: 'Portals'
            },
            {
              url: '/payment-conditions',
              text: 'Payment Conditions',
              display: this.hasPermission('admin')
            },
            {
              url: '/project-categories',
              text: 'Project Categories',
              display: this.hasPermission('admin')
            },
            {
              url: '/legal-texts',
              text: 'Legal Texts',
              display: this.hasPermission('admin')
            },
            {
              url: '/competitions',
              text: 'Competitions',
              display: this.hasPermission('admin')
            },
            {
              url: '/subscription-types',
              text: 'Subscription Types',
              display: this.hasPermission('admin')
            },
            {
              url: '/tags',
              text: 'Tags'
            },
            {
              url: '/users',
              text: 'Users',
              display: this.hasPermission('admin')
            },
            {
              url: '/untracked-email-addresses',
              text: 'Untracked Email Addresses',
              display: this.hasPermission('admin')
            },
            {
              url: '/marketing-sites',
              text: 'Marketing Sites'
            },
            {
              url: '/retention-touchpoints',
              text: 'Retention Touchpoints'
            },
            {
              url: '/gallery',
              text: 'Images'
            }
          ]
        }
      ]
    }
  },

  methods: {
    search() {
      this.$router.push('/search?term=' + this.term)

      this.showSearch = false

      this.term = ''
    }
  }
}
</script>
